import { WheelOptionsClasses } from '../enums/WheelOptionsClasses';
import { RedBlueBettingOptionClasses } from '../enums/RedBlueBettingOptionClasses';
import { RouletteOptionsClasses } from '../enums/RouletteOptionsClasses';
export var WHEEL_CASINO_OPTIONS_CLASSES = [
    WheelOptionsClasses.NUMBERS,
    WheelOptionsClasses.CUP,
    WheelOptionsClasses.BLACK,
    WheelOptionsClasses.GREY,
    WheelOptionsClasses.RED,
    WheelOptionsClasses.FROM_1_TO_6,
    WheelOptionsClasses.FROM_13_TO_18,
    WheelOptionsClasses.FROM_7_TO_12,
];
export var RED_BLUE_CASINO_OPTIONS_CLASSES = [
    RedBlueBettingOptionClasses.RED,
    RedBlueBettingOptionClasses.DRAW,
    RedBlueBettingOptionClasses.BLUE,
    RedBlueBettingOptionClasses.CORRECT_RED,
    RedBlueBettingOptionClasses.CORRECT_BLUE,
    RedBlueBettingOptionClasses.CORRECT_RED_BLUE,
];
export var ROULETTE_CASINO_OPTIONS_CLASSES = Object.values(RouletteOptionsClasses);
